export default __webpack_public_path__ + "static/media/vigilance-section.5c1f0b45.webp";